export default "__VITE_ASSET__BouwRts7__"